import React, { useEffect, useState } from 'react';
import { Button, ButtonStyles, Icons, SelectList } from '@silverfort/sf-components';
import moment from 'moment';
import useGetReportFilesData from '../../api/queries/useGetReportFilesData';
import { downloadFile } from '../../../../components/utils';
import RiskReportPopup from '../../RiskReportPopup/RiskReportPopup';
import InsuranceReportPopup from '../../InsuranceReportPopup/InsuranceReportPopup';

type ReportItem = {
    disabled?: boolean;
    title: string;
    value: () => void;
};

const REPORT_DATE_FORMAT = 'MM/DD/YYYY,HH:mm:ss';
const REPORT_NO_DATE_STRING = 'N\\A';

const IspmReportsSelect = () => {
    const { data: reportFilesData, refreshData } = useGetReportFilesData();

    const [showReportSettingsModal, setShowReportSettingsModal] = useState(false);
    const [showInsuranceSettingsModal, setShowInsuranceSettingsModal] = useState(false);

    useEffect(() => {
        const locale = navigator.languages ? navigator.languages : navigator.language;

        moment.locale(locale.toString());
    }, []);

    const onItemSelected = (value?: Array<ReportItem['value']> | ReportItem['value']) => {
        if (!value) return;

        if (Array.isArray(value)) {
            value.forEach((item) => {
                item();
            });
        } else {
            value();
        }
    };

    const parseReportDate = (date?: string) => {
        return date ? moment(new Date(date)).format(REPORT_DATE_FORMAT) : REPORT_NO_DATE_STRING;
    };

    const items: Array<ReportItem> = [
        {
            title: 'Generate risk report',
            value: () => {
                setShowReportSettingsModal(true);
            }
        },
        {
            disabled: !reportFilesData?.riskReportFileName,
            title: `Download last risk report (${parseReportDate(reportFilesData?.riskReportFileDate)})`,
            value: () => {
                if (reportFilesData?.riskReportFileName) {
                    downloadFile('/insights/downloadLastReportData', reportFilesData?.riskReportFileName);
                }
            }
        },
        {
            disabled: !reportFilesData?.scheduledRiskReportFileName,
            title: `Download last scheduled risk report`,
            value: () => {
                downloadFile('/insights/downloadLastScheduledRiskReport');
            }
        },
        {
            title: 'Generate insurance report',
            value: () => {
                setShowInsuranceSettingsModal(true);
            }
        },
        {
            disabled: !reportFilesData?.insuranceFileName,
            title: `Download last insurance report (${parseReportDate(reportFilesData?.insuranceFileDate)})`,
            value: () => {
                if (reportFilesData?.insuranceFileName) {
                    downloadFile('/insights/downloadLastInsuranceData', reportFilesData?.insuranceFileName);
                }
            }
        }
    ];

    return (
        <>
            <SelectList
                TriggerComponent={Button}
                items={items}
                menuClassName="!w-[382px]"
                menuProps={{
                    disableAutoFocus: true
                }}
                onChange={onItemSelected}
                triggerProps={{
                    buttonStyle: ButtonStyles.Primary,
                    iconLeft: Icons.Checklist,
                    text: 'Reports'
                }}
            />

            {showReportSettingsModal && (
                <RiskReportPopup
                    onClose={() => setShowReportSettingsModal(false)}
                    open={showReportSettingsModal}
                    refreshReportFilesData={refreshData}
                    settings={reportFilesData?.reportSettings}
                />
            )}

            {showInsuranceSettingsModal && (
                <InsuranceReportPopup
                    onClose={() => setShowInsuranceSettingsModal(false)}
                    open={showInsuranceSettingsModal}
                    refreshReportFilesData={refreshData}
                />
            )}
        </>
    );
};

export default IspmReportsSelect;
